import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { useTranslation } from 'react-i18next';
import { Consultant } from '../../interfaces/Consultant';
import { ConsultantActionCreators } from '../../store/consultants';
import { dataActionCreators } from '../../store/Data';
import { Avatar, Badge, Button, Link, Spinner, Text, Toast, ToastTitle, ToastTrigger, useToastController } from '@fluentui/react-components';
import { ArrowImport24Filled, Dismiss24Filled, Edit24Filled } from "@fluentui/react-icons";
import { useQuickViewStyles } from '../Styles/QuickView';
import * as TeamsState from '../../store/TeamsState';
import { useMsal } from '@azure/msal-react';
import { TokenHelper } from '../../TokenHelper';
import { useRigths } from '../Tools/ObjectLoader';

export const ConsultantsQuickView = () => {
    const teamsState = useSelector<ApplicationState, TeamsState.TeamsState>((state: ApplicationState) => state.teamsState);
    const { instance } = useMsal();
    const consultantQuickView = useSelector<ApplicationState, Consultant | null>((state: ApplicationState) => state.consultantsState.consultantQuickView);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const viewDebugInfo = useSelector((state: ApplicationState) => state.userNeomyticLogin.viewDebugInfo);
    const styles = useQuickViewStyles();
    const { dispatchToast, updateToast } = useToastController("NeoToasterUnique");
    const { isAdmin } = useRigths();

    React.useEffect(() => {
        if (consultantQuickView && consultantQuickView.peppolStatus === undefined) {
            dispatch(ConsultantActionCreators.requestConsultantsPeppolStatus(instance, teamsState, consultantQuickView));
        }
    }, [consultantQuickView]);

    const submitPeppolRegistration = (env: string) => {
        if (consultantQuickView) {
            TokenHelper.GetToken(instance, teamsState)
                .then(token => {
                    const toastId = (Math.random() + 1).toString(36).substring(7);
                    dispatchToast(
                        <Toast appearance="inverted">
                            <ToastTitle>
                                {"registering " + consultantQuickView.consultantid + " to peppol..."}
                            </ToastTitle>
                        </Toast>,
                        { intent: "info", timeout: -1, position: "top-end", toastId: toastId }
                    );
                    if (token !== null) {
                        fetch("api/Consultants/" + consultantQuickView.consultantid + "/peppol/register/" + env, {
                            method: "PUT",
                            headers: {
                                "Content-Type": "application/json",
                                authorization: "bearer " + token,
                            },
                            mode: "cors",
                            cache: "default",
                        })
                            .then(response => {
                                if (response.status === 200) {
                                    updateToast({
                                        content: (
                                            <Toast appearance="inverted">
                                                <ToastTitle action={
                                                    <ToastTrigger>
                                                        <Link>Dismiss</Link>
                                                    </ToastTrigger>
                                                }>
                                                    {"registering " + consultantQuickView.consultantid + " to peppol is succefull"}
                                                </ToastTitle>
                                            </Toast>
                                        ),
                                        intent: "success",
                                        toastId,
                                        timeout: 5000,
                                    });
                                }
                                else {
                                    updateToast({
                                        content: (
                                            <Toast appearance="inverted">
                                                <ToastTitle action={
                                                    <ToastTrigger>
                                                        <Link>Dismiss</Link>
                                                    </ToastTrigger>
                                                }>
                                                    {"registering " + consultantQuickView.consultantid + " to peppol failed"}
                                                </ToastTitle>
                                            </Toast>
                                        ),
                                        intent: "error",
                                        toastId,
                                        timeout: 10000,
                                    });
                                }
                            });
                    }
                });
        }
    };


    if (consultantQuickView) {
        return (
            <div className={styles.root} >
                <div className={styles.titleAndOps}>
                    <h2>{t('Consultant') + " : " + (consultantQuickView.displayName ? consultantQuickView.displayName : "?")}</h2>
                    <div className={styles.titleAndOpsButtons}>
                        <Button icon={<Edit24Filled />} shape="circular" title={t('Edit')} onClick={() => dispatch(ConsultantActionCreators.requestConsultantEdition(consultantQuickView))} />
                        <Button icon={<Dismiss24Filled />} shape="circular" title="Close" onClick={() => dispatch(dataActionCreators.requestClearQuickView())} />
                    </div>
                </div>
                {consultantQuickView.photo && <Avatar
                    size={96}
                    image={{
                        alt: consultantQuickView.displayName ? consultantQuickView.displayName : "?",
                        src: consultantQuickView.photo,
                    }}
                />}
                {viewDebugInfo &&
                    <>
                        <h2>Id</h2>
                        <Text truncate >{consultantQuickView.consultantid}</Text>
                    </>
                }
                <h2>{t('FirstName')}</h2>
                {consultantQuickView.firstName ? <Text truncate>{consultantQuickView.firstName}</Text> : "-"}
                <h2>{t('LastName')}</h2>
                {consultantQuickView.lastName ? <Text truncate>{consultantQuickView.lastName}</Text> : "-"}
                <h2>{t('CompanyName')}</h2>
                {consultantQuickView.companyName ? <Text truncate>{consultantQuickView.companyName}</Text> : "-"}
                <h2>{t('PrivateEmail')}</h2>
                {consultantQuickView.privateEmail ? <Text truncate>{consultantQuickView.privateEmail}</Text> : "-"}
                <h2>{t('PhoneNumber')}</h2>
                {consultantQuickView.phoneNumber ? <Text truncate>{consultantQuickView.phoneNumber}</Text> : "-"}
                <h2>{t('website')}</h2>
                {consultantQuickView.website ? <Text truncate>{consultantQuickView.website}</Text> : "-"}
                <h2>{t('CompanyNumber')}</h2>
                {consultantQuickView.companyNumber ? <Text truncate>{consultantQuickView.companyNumber}</Text> : "-"}
                <h2>{t('VAT')}</h2>
                {consultantQuickView.vat ? <Text truncate>{consultantQuickView.vat}</Text> : t('NotDefined')}
                <h2>IBAN</h2>
                {consultantQuickView.iban ? <Text truncate>{consultantQuickView.iban}</Text> : t('NotDefined')}
                <h2>{t('Address')}</h2>
                {consultantQuickView.address === null
                    && consultantQuickView.address2 === null
                    && consultantQuickView.address3 === null
                    && consultantQuickView.postalCode === null
                    && consultantQuickView.city === null
                    && consultantQuickView.country === null
                    && "-"}
                {consultantQuickView.address && <Text truncate>{consultantQuickView.address}</Text>}
                {consultantQuickView.address2 && <Text truncate>{consultantQuickView.address2}</Text>}
                {consultantQuickView.address3 && <Text truncate>{consultantQuickView.address3}</Text>}
                {consultantQuickView.postalCode && <Text truncate>{consultantQuickView.postalCode}</Text>}
                {consultantQuickView.city && <Text truncate>{consultantQuickView.city}</Text>}
                {consultantQuickView.country && <Text truncate>{consultantQuickView.country}</Text>}
                {isAdmin && <>
                    <h2>{t('ActivitiesPeriods')}</h2>
                    {consultantQuickView.consultantActivityPeriodes && consultantQuickView.consultantActivityPeriodes.length > 0
                        ? consultantQuickView.consultantActivityPeriodes.map(ap =>
                            <div className={styles.InlineRow}>
                                <Text truncate>{ap.dateDebut ? new Date(ap.dateDebut).toLocaleDateString() : "-"}</Text>
                                <ArrowImport24Filled className={styles.iconmarge} />
                                <Text truncate>{ap.dateFin ? new Date(ap.dateFin).toLocaleDateString() : "-"}</Text>
                            </div>)
                        : <Text truncate>{t('NoActivitiesPeriods')}</Text>
                    }
                </>
                }
                <h2>Peppol eInvoice</h2>
                {consultantQuickView.peppolStatus === undefined &&
                    <Spinner size="tiny" />
                }
                {consultantQuickView.peppolStatus && consultantQuickView.peppolStatus.prod.length === 0 &&
                    <Text truncate>{t('NotRegistered')}</Text>
                }
                {consultantQuickView.peppolStatus &&
                    consultantQuickView.peppolStatus.prod.map(e => {
                        return <div key={"Prod" + e.peppolIdentifier} style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "flex-start", width: "max-content" }}>
                            <Text truncate>{e.peppolIdentifier + " " + (e.isRegistered ? t('Registered') : t('NotRegistered'))}</Text>
                            <Badge appearance="filled" color={e.supportedDocuments && e.supportedDocuments.canReceiveInvoices ? "success" : "danger"}>
                                Invoice
                            </Badge>
                            <Badge appearance="filled" color={e.supportedDocuments && e.supportedDocuments.canReceiveCreditNotes ? "success" : "danger"}>
                                Credit Note
                            </Badge>
                            <Badge appearance="filled" color={e.supportedDocuments && e.supportedDocuments.canReceiveMLR ? "success" : "informative"}>
                                MLR
                            </Badge>
                            <Badge appearance="filled" color={e.supportedDocuments && e.supportedDocuments.canReceiveInvoiceResponse ? "success" : "informative"}>
                                Invoice Response
                            </Badge>
                        </div>;
                    })
                }
                {consultantQuickView.peppolStatus && consultantQuickView.peppolRegisterProd && consultantQuickView.peppolStatus.prod.length === 0 &&
                    <Button
                        onClick={() => {
                            submitPeppolRegistration("prod");
                        }}
                    >
                        {t('RegisterInPeppolProdNetwork')}
                    </Button>
                }
                {isAdmin && <>
                    <h2>Peppol eInvoice Test</h2>
                    {consultantQuickView.peppolStatus === undefined &&
                        <Spinner size="tiny" />
                    }
                    {consultantQuickView.peppolStatus && consultantQuickView.peppolStatus.test.length === 0 &&
                        <Text truncate>{t('NotRegistered')}</Text>
                    }
                    {consultantQuickView.peppolStatus &&
                        consultantQuickView.peppolStatus.test.map(e => {
                            return <div key={"Test" + e.peppolIdentifier} style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "flex-start", width: "max-content" }}>
                                <Text truncate>{e.peppolIdentifier + " " + (e.isRegistered ? t('Registered') : t('NotRegistered'))}</Text>
                                <Badge appearance="filled" color={e.supportedDocuments && e.supportedDocuments.canReceiveInvoices ? "success" : "warning"}>
                                    Invoice
                                </Badge>
                                <Badge appearance="filled" color={e.supportedDocuments && e.supportedDocuments.canReceiveCreditNotes ? "success" : "warning"}>
                                    Credit Note
                                </Badge>
                                <Badge appearance="filled" color={e.supportedDocuments && e.supportedDocuments.canReceiveMLR ? "success" : "informative"}>
                                    MLR
                                </Badge>
                                <Badge appearance="filled" color={e.supportedDocuments && e.supportedDocuments.canReceiveInvoiceResponse ? "success" : "informative"}>
                                    Invoice Response
                                </Badge>
                            </div>;
                        })
                    }
                    {consultantQuickView.peppolStatus && consultantQuickView.peppolRegisterDev && consultantQuickView.peppolStatus.test.length === 0 &&
                        <Button
                            onClick={() => {
                                submitPeppolRegistration("test");
                            }}
                        >
                            {t('RegisterInPeppolTestNetwork')}
                        </Button>
                    }
                </>
                }
            </div>
        );
    }
    return null;
};